import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
    selector: '[inputTitleCase]',
    standalone: false
})
export class TitleCaseDirective {

  constructor(private el: ElementRef) {
  }

  @HostListener('blur') onBlur() {
    if (this.el.nativeElement.value) {
      let arr: string[] = this.el.nativeElement.value.split(' ')
      for (let i = 0; i < arr.length; i++) {
        arr[i] = arr[i].charAt(0).toUpperCase() + arr[i].slice(1)
      }

      this.el.nativeElement.value = arr.join(' ')
    }
  }
}
